export class SetHasVisitedInstallersList {
  public static readonly type = '[InstallersState] Set Has Visited Installers List';

  constructor(public visited: boolean) {}
}
